import { render, staticRenderFns } from "./commentTable.vue?vue&type=template&id=7ea676c0"
import script from "./commentTable.vue?vue&type=script&lang=js"
export * from "./commentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports